import { useEffect } from 'react';

/* Light anti-copy for licenced content: block context menu / selection, override
   copy with an attribution string, and clear the console if devtools look open.
   Convenience deterrent, not real DRM. Shared by the Roadmap and the Planner. */
export default function useAntiCopy() {
  useEffect(() => {
    const block = (e) => e.preventDefault();
    const overrideCopy = (e) => {
      e.preventDefault();
      e.clipboardData?.setData('text/plain', '© Narratoria Ltd — Licenced Content.');
    };
    const warnDevTools = () => {
      if (window.outerWidth - window.innerWidth > 160 || window.outerHeight - window.innerHeight > 160) {
        console.clear();
      }
    };
    document.addEventListener('contextmenu', block);
    document.addEventListener('selectstart', block);
    document.addEventListener('copy', overrideCopy);
    window.addEventListener('resize', warnDevTools);
    warnDevTools();
    return () => {
      document.removeEventListener('contextmenu', block);
      document.removeEventListener('selectstart', block);
      document.removeEventListener('copy', overrideCopy);
      window.removeEventListener('resize', warnDevTools);
    };
  }, []);
}
